import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import DashboardLayout from '@/components/DashboardLayout'
import EventForm from '@/components/EventForm'

type NewEventProps = {
  dress_codes: string[]
  causes: string[]
  initial_page_kind: 'event' | 'fundraiser'
  initial_payment_mode: 'native' | 'external'
  initial_external_url: string | null
  stripe_payment_ready: boolean
}

export default function DashboardEventsNew({
  dress_codes,
  causes,
  initial_page_kind,
  initial_payment_mode,
  initial_external_url,
  stripe_payment_ready,
}: NewEventProps) {
  return (
    <>
      <Head title="Create Campaign" />
      <EventForm
        dressCodes={dress_codes}
        causes={causes}
        initialPageKind={initial_page_kind}
        initialPaymentMode={initial_payment_mode}
        initialExternalUrl={initial_external_url}
        stripePaymentReady={stripe_payment_ready}
      />
    </>
  )
}

DashboardEventsNew.layout = (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>
